import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiAxios from "helpers/apiAxios";
import { toast } from "react-toastify";

import {
  initialState,
  handleFulfilled,
  setNestedPageHelper,
  setNestedPageSizeHelper,
  setNestedParamsHelper,
  resetNestedParamsHelper,
  setSortParamsHelper,
  setFilterTagHelper,
  resetFilterTagHelper,
  handlePayload
} from "helpers/reducerHelpers";
import { objectSerializer } from "helpers/utils";

const shipmentPlanUrl = "/crm/shipment/order_intakes";

export const getOrderIntakes = createAsyncThunk(
  "Shipment/getOrderIntakes",
  async (params) => {
    try {
      const response = await apiAxios.get(shipmentPlanUrl, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const exportData = createAsyncThunk(
  "Shipment/exportData",
  async (params) => {
    //remove page and per_page in object
    const { page, per_page, ...rest } = params
    console.log(rest, page, per_page)

    const response = await apiAxios.get(`${shipmentPlanUrl}/export`, {params, responseType: 'blob'})
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `order-shipment.xlsx`);
    document.body.appendChild(link);
    link.click();
  }
)

export const adjustmentBacklog = createAsyncThunk(
  "Shipment/adjustmentBacklog",
  async ({ recordId, data }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.put(`${shipmentPlanUrl}/${recordId}`, data)
      return response.data
    }
    catch(error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const generatePeriodOrder = createAsyncThunk(
  "Shipment/generatePeriodOrder",
  async (params) => {
    try {
      const response = await apiAxios.post(`${shipmentPlanUrl}/generate_period`, params)
      return response.data;
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const recalculatePeriod = createAsyncThunk(
  "Shipment/recalculatePeriod",
  async (period) => {
    try {
      const response = await apiAxios.post(`${shipmentPlanUrl}/recalculate`, {period})
      return response.data;
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

const isRejectedAction = (action) => (action.type.startsWith("Shipment/")) && action.type.endsWith("/rejected");

const orderIntakeSlice = createSlice({
  name: "crm_shipment_order_intake",
  initialState: {
    ...initialState,
  },
  reducers: {
    setNestedPage: setNestedPageHelper,
    setNestedPageSize: setNestedPageSizeHelper,
    setNestedParams: setNestedParamsHelper,
    resetNestedParams: resetNestedParamsHelper,
    setSortParams: setSortParamsHelper,
    setFilterTag: setFilterTagHelper,
    resetFilterTag: resetFilterTagHelper
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderIntakes.fulfilled, (state, action) => {
        handleFulfilled(state, action, "allData")
        // Extract summary data for YTD report
        if (action.payload?.summary) {
          state.allData.summaryData = {
            productions: action.payload.summary.productions,
            regional_monthly: action.payload.summary.regional_monthly,
            regional_yearly: action.payload.summary.regional_yearly
          }
        }
      })
      .addCase(adjustmentBacklog.fulfilled, (state, action) => {
        handlePayload(state, action)
      })
      .addCase(generatePeriodOrder.fulfilled, (state, action) => {
        const {data, message, error} = action.payload;

        if (error) {
          toast.error(error);
        }
        else {
          if (data) {
            const newData = objectSerializer(data);
            state.allData.data = [...newData, ...state.allData.data];
          }

          toast.success(message);
        }

      })
      .addCase(recalculatePeriod.fulfilled, (state, action) => {
        const {data, message, error} = action.payload;

        if (error) {
          toast.error(error);
        }
        else {
          if (data) {
            const newData = objectSerializer(data);
            state.allData.data = [...newData, ...state.allData.data];
          }

          toast.success(message);
        }

      })
      .addCase(exportData.pending, (state) => {
        state.exporting = true
      })
      .addCase(exportData.fulfilled, (state) => {
        state.exporting = false
       // toast.success("Data has been exported successfully.")
      })
      .addMatcher(
        isRejectedAction,
        (state, action) => {
          state.loading = false;
          toast.error(action.payload?.message || action.payload?.error || action?.error?.message)
        }
      );
  }
})

export const {
  setNestedPage,
  setNestedPageSize,
  setNestedParams,
  resetNestedParams,
  setSortParams,
  setFilterTag,
  resetFilterTag
} = orderIntakeSlice.actions;

export default orderIntakeSlice.reducer;